import React, { useState, useRef, useEffect, useContext } from 'react'
import { ColumnsTable } from 'safe'
// import { RiArrowDropDownLine } from 'react-icons/ri'
import { AnimatePresence } from 'framer-motion'
import '../../assets/css/components/Display/Table.css'
import { ColumnItemWrapper } from '../General/ColumnItemWrapper'
import { ArrowsIcons } from '../General/ArrowsIcons'
import { ThemeContext } from '../../context/ThemeContext'

const Pagination = React.lazy(() => import('../Navigation/Pagination'))
const AiOutlineInbox = React.lazy(() => import('react-icons/ai').then(module => ({ default: module.AiOutlineInbox })))
const InputCheck = React.lazy(() => import('../Inputs/InputCheck'))
const Loading = React.lazy(() => import('./Loading'))
const Tooltip = React.lazy(() => import('./Tooltip'))

const Table: React.FC<TableProps> = ({
  data,
  columns,
  // maxRows,
  loading = false,
  // rowCollapsedRender,
  // getCollapsed,
  onPressButton,
  // setLoading = () => { },
  pages = 1,
  pageSelected = 0,
  setPageSelected = () => {},
  getOrderKeys = (key: string) => [key],
  showPagination = true,
  isArraySelectable = false,
  selectedData = [],
  setSelectedData = () => {},
  selectedRow,
  fetchPage,
  isBigPagination = true,
  applyBackgroundHover = false,
  evaluateNegativeRow = false
}) => {
  const [actualColumnKey, setActualColumnKey] = useState('')
  // const [collapsedKeys, setCollapsedKeys] = useState<number[]>([])
  const [orderASC, setOrderASC] = useState(0)
  const [allChecked, setAllChecked] = useState<boolean>(false)
  /* Ref para obtener el height de la tabla */
  let tableRef = useRef<HTMLTableElement | null>(null)

  const { theme, setTheme } = useContext(ThemeContext)

  const localColumns = [...columns]
  if (isArraySelectable) {
    localColumns.unshift({
      title: 'checkbox',
      dataIndex: 'checkbox',
      align: 'left',
      key: 'checkbox',
    })
  }

  // useEffect(() => {
  //   if (getCollapsed) getCollapsed(collapsedKeys)
  // }, [collapsedKeys, getCollapsed])

  const setAlign = (align) =>
    align === 'center'
      ? 'text-center'
      : align === 'right'
      ? 'text-right'
      : 'text-left'

  // const onCollapsed = (index: number) => {
  //   collapsedKeys.includes(index)
  //     ? setCollapsedKeys(collapsedKeys.filter((k) => k !== index))
  //     : setCollapsedKeys([...collapsedKeys, index])
  // }

  function compareColumnValues(a, b) {
    let value = 0
    if ((typeof a && typeof b) === 'number') {
      value = (a - b) * orderASC
    } else {
      value = String(a).localeCompare(String(b)) * -orderASC
    }
    return value
  }

  function orderColumns(fisrtElement, secondElement) {
    let value = 0
    const columnKey = getOrderKeys(actualColumnKey, secondElement)

    if (columnKey.length === 3) {
      value = compareColumnValues(
        fisrtElement[columnKey[0]][0][columnKey[2]],
        secondElement[columnKey[0]][0][columnKey[2]]
      )
    } else if (columnKey.length === 2) {
      value = compareColumnValues(
        fisrtElement[columnKey[0]][columnKey[1]],
        secondElement[columnKey[0]][columnKey[1]]
      )
    } else {
      value = compareColumnValues(
        fisrtElement[columnKey[0]],
        secondElement[columnKey[0]]
      )
    }
    return value
  }

  function handleCheck(record) {
    if (!selectedData.find((element) => element.id === record.id)) {
      console.log('if')
      setSelectedData((state) => [...state, record])
    } else {
      console.log('else')
      setSelectedData((state) =>
        state.filter((element) => element.id !== record.id)
      )
    }
  }

  function selectOrDeselect(selected: boolean): boolean {
    if (!selected) {
      setSelectedData([...data])
      return true
    } else {
      setSelectedData([])
      return false
    }
  }

  const [windowSize, setWindowSize] = useState(getWindowSize());

  useEffect(() => {
    function handleWindowResize() {
      setWindowSize(getWindowSize());
    }

    window.addEventListener('resize', handleWindowResize);

    return () => {
      window.removeEventListener('resize', handleWindowResize);
    };
  }, []);

  function getWindowSize() {
    const {innerWidth, innerHeight} = window;
    return {innerWidth, innerHeight};
  }

  return (
    <>
      <div className={`overflow-auto ${windowSize.innerWidth > 1200 && 'lg:overflow-visible'}`}>
        <table
          className="w-full dark:tableDark tableLight"
          // style={{ opacity: loading ? '0.5' : '1.0' }}
          ref={tableRef}
        >
          <thead>
            <tr>
              {/* {rowCollapsedRender && (
                <th scope="col" className="w-12">
                  {' '}
                </th>
              )} */}
              {localColumns.map(({ title, align, key, width }) => (
                <th
                  scope="col"
                  key={`${key}-head`}
                  className={`${setAlign(
                    align
                  )} px-6 pb-6 text-xs font-semibold text-primary-900 dark:text-white text-black capitalize tracking-wider`}
                  style={{
                    width,
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                  }}
                >
                  {title && title === 'checkbox' ? (
                    <div className="flex flex-row" style={{marginLeft: -10, marginTop: 3}}>
                      <InputCheck
                        checked={allChecked}
                        onChange={() =>
                          setAllChecked((prev) => selectOrDeselect(prev))
                        }
                      />
                    </div>
                  ) : title ? (
                    <div className="flex flex-row	">
                      <p className="mr-2" id={key}>
                        {title}
                      </p>
                      {/* <ArrowsIcons
                        order={orderASC}
                        orderSetter={setOrderASC}
                        onClick={() => {
                          setActualColumnKey(key)
                        }}
                        active={actualColumnKey === key}
                      /> */}
                    </div>
                  ) : null}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data?.length > 0 ? (
              data
                .sort((a, b) => orderColumns(a, b))
                .map((record, di) => (
                  <React.Fragment key={'row-' + di}>
                    <tr
                      key={'p' + pageSelected + '-r' + di}
                      className={`${
                        selectedRow && +selectedRow === +record.id && 'border-2'
                      } ${applyBackgroundHover && (theme === 'dark' ? 'table-row-dark' : 'table-row')}`}
                      style={{
                        background:
                        evaluateNegativeRow &&
                          record &&
                          +record?.quantity < 0 &&
                          'rgba(255, 56, 56, 0.2)',
                        opacity:
                          record &&
                          record?.enable !== undefined &&
                          !record?.enable &&
                          0.4,
                          cursor: 'pointer'
                      }}
                    >
                      {/* {rowCollapsedRender && (
                        <td className="pl-4 pr-2 whitespace-nowrap">
                          <div
                            onClick={() => onCollapsed(di)}
                            className="flex cursor-pointer items-center text-primary dark:text-primary-dark justify-center"
                          >
                            {
                              <RiArrowDropDownLine
                                size="1.6rem"
                                className={`transition-all ${
                                  collapsedKeys.includes(di) &&
                                  '-rotate-180 transform'
                                }`}
                              />
                            }
                          </div>
                        </td>
                      )} */}
                      {localColumns.map(
                        ({ dataIndex, align, key, render, width, title, tootltipValue }, ci) => {
                          const paths = dataIndex.split('.')
                          const value = paths.reduce(
                            (obj, path) => (obj || {})[path],
                            record
                          ) // Oliver Steel Nested Access Pattern
                          return (
                            <td
                              style={{
                                maxWidth: width || 150,
                              }}
                              key={`r${di}-${key}${ci + 1}`}
                              className={`${setAlign(align)}`}
                              onClick={() => {
                                // if (
                                //   onPressButton && !isArraySelectable &&
                                //   localColumns.length - 1 !== ci
                                // )
                                // console.log("title...", title)
                                title && onPressButton && onPressButton(record)
                              }}
                            >
                            { tootltipValue ? (
                            <Tooltip title={record[key]} position='top' right={record[key].length > 30 ? `-200px` : ''}>
                              {render ? (
                                render(value, record, di)
                              ) : isArraySelectable && ci === 0 ? (
                                <InputCheck
                                  classes="mt-3 ml-3"
                                  checked={selectedData.find(
                                    (element) => element.id === record.id
                                  )}
                                  onChange={() => handleCheck(record)}
                                />
                              ) : (
                                <ColumnItemWrapper subElement="paragraph">
                                  {typeof value === 'object' && value !== null
                                    ? JSON.stringify(value)
                                    : value || ''}
                                </ColumnItemWrapper>
                              )}
                              </Tooltip>
                            ) : render ? (
                              render(value, record, di)
                            ) : isArraySelectable && ci === 0 ? (
                              <InputCheck
                                classes="mt-3 ml-3"
                                checked={selectedData.find(
                                  (element) => element.id === record.id
                                )}
                                onChange={() => handleCheck(record)}
                              />
                            ) : (
                              <ColumnItemWrapper subElement="paragraph">
                                {typeof value === 'object' && value !== null
                                  ? JSON.stringify(value)
                                  : value || ''}
                              </ColumnItemWrapper>
                            ) }
                            </td>
                          )
                        }
                      )}
                    </tr>
                    <AnimatePresence initial={false}>
                      {/* {rowCollapsedRender && collapsedKeys.includes(di) && (
                        <tr
                          key={'p' + pageSelected + '-r' + di + 'coll'}
                          className="bg-gray-100 bg-opacity-10 dark:bg-gray-900 dark:bg-opacity-30"
                        >
                          <td colSpan={9999}>
                            <motion.div
                              initial="collapsed"
                              animate="open"
                              exit="collapsed"
                              transition={{
                                duration: 0.3,
                                ease: [0.04, 0.62, 0.23, 0.98],
                              }}
                              variants={{
                                open: { opacity: 1, height: 'max-content' },
                                collapsed: { opacity: 0, height: 0 },
                              }}
                            >
                              {rowCollapsedRender(
                                record,
                                collapsedKeys.includes(di),
                                di
                              )}
                            </motion.div>
                          </td>
                        </tr>
                      )} */}
                    </AnimatePresence>
                  </React.Fragment>
                ))
            ) : (
              <tr>
                <td colSpan={9999}>
                  <div className="h-60 text-gray-400 flex justify-center flex-col items-center bg-transparent text-center">
                    <AiOutlineInbox size="2.4rem" />
                    <p className="text-base">No hay datos</p>
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>

        {showPagination && (
          <div className={`${isBigPagination ? 'mt-4' : 'w-max py-1'}`}>
            <Pagination
              selected={pageSelected}
              pages={pages}
              onChange={(selected) => fetchPage ? fetchPage(selected) : setPageSelected(selected)}
            />
          </div>
        )}
        {loading && <Loading />}
      </div>
    </>
  )
}

export default Table

interface TableProps {
  columns: ColumnsTable[]
  data: any[]
  // maxRows?: number
  loading?: boolean
  rowCollapsedRender?: (
    record: any,
    collapsed: boolean,
    index: number
  ) => React.ReactNode
  getCollapsed?: Function
  onPressButton?: (record: any) => void
  setLoading?: Function
  pages?: number
  pageSelected?: number
  setPageSelected?: Function
  getOrderKeys?: Function
  showPagination?: boolean
  // makes table with simple selectable functionality
  selectedRow?: number
  // makes table with multiple selectable functionality
  isArraySelectable?: boolean
  selectedData?: any[]
  setSelectedData?: Function
  fetchPage?: (page: number) => void
  isBigPagination? : boolean
  applyBackgroundHover?: boolean
  evaluateNegativeRow?: boolean
}
